import { render, staticRenderFns } from "./UnscheduledModelDetail.vue?vue&type=template&id=7612b2d6&scoped=true"
import script from "./UnscheduledModelDetail.vue?vue&type=script&lang=js"
export * from "./UnscheduledModelDetail.vue?vue&type=script&lang=js"
import style0 from "./UnscheduledModelDetail.vue?vue&type=style&index=0&id=7612b2d6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7612b2d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7612b2d6')) {
      api.createRecord('7612b2d6', component.options)
    } else {
      api.reload('7612b2d6', component.options)
    }
    module.hot.accept("./UnscheduledModelDetail.vue?vue&type=template&id=7612b2d6&scoped=true", function () {
      api.rerender('7612b2d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/unscheduledmodel/UnscheduledModelDetail.vue"
export default component.exports